import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={
                'https://order.codefusion.tech/restaurants/vz16CF1IMCnfjQv2zShK/locations/8fKDBbEDhiuey7Y3DXff'
              }
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="70%"
                  maxWidth="=250px"
                  alt="Order Pickup Button"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={
                'https://order.codefusion.tech/restaurants/vz16CF1IMCnfjQv2zShK/locations/8fKDBbEDhiuey7Y3DXff'
              }
              target="_blank"
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="25vw"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
